import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Welcome from "../pages/Welcome";
import CartPage from "../pages/Cart/CartPage";
import Layout from "../components/controls/Layout";
import LoginPage from "../pages/login/LoginPage";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import OrdersToValidate from "../pages/Admin/OrdersToValidate";
import CreateEventPage from "../pages/EventCreation/EventCreationWizard";
import ProviderDashboard from "../pages/Provider/ProviderDashboard";
import BecomeProvider from "../pages/Provider/BecomeProviderPage";
import ProductsList from "../pages/Provider/ProductsList";
import ProviderRequests from "../pages/Admin/ProviderRequests";
import HomePage from "../pages/HeroSection2";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import ProviderProfile from "../pages/Provider/Profile";
import Providers from "../pages/Admin/Providers";
import Unauthorized from "../pages/unauthorized";
import ServicesList from "../pages/Provider/ServicesList";
import BecomePartner from "../pages/BecomePartner/BecomePartner";
import ProviderSubscriptions from "../pages/Provider/ProviderSubscriptions";
import ProviderEditPage from "../pages/Provider/ProviderEditPage";
import JiraTicketsTable from "../pages/Representatives/JiraTicketsTable";

import TermsAndConditions from "../pages/Footer/TermsAndConditions/TermsAndConditions";
import Companies from "../pages/Companies/Companies";
import AllCompanies from "../pages/Companies/AllCompaniesList";
import RegisterCompany from "../pages/Companies/RegisterCompany";
import ContactPage from "../pages/Footer/ContactUs";
import PaymentPage from "../pages/Cart/PaymentPage.";
import SuccessPage from "../pages/Cart/CheckoutSuccessPage";
import MyOrdersPage from "../pages/Customer/MyOrdersPage";
import CurrentOrders from "../pages/Provider/CurrentOrders";
import SubscriptionSuccess from "../pages/BecomePartner/SubscriptionSuccess";
import CreateEditProduct from "../pages/Provider/items/CreateEditProduct";
import LoadingOverlay from "../contexts/LoadingOverlay";
import SuccessDonation from "../pages/BecomePartner/DonationSuccess";
import CreateTicketingForm from "../pages/Tickets/CreateTicketing";
import EventTicketPage from "../pages/Tickets/EventTicketPage";
import TicketSuccess from "../pages/Tickets/TicketSuccess";
import TicketingListPage from "../pages/Tickets/AdminTicketingList";
import TicketingEventList from "../pages/Tickets/UpcomingEvents";
import AdminTicketValidation from "../pages/Tickets/AdminTicketValidation";
import UserList from "../pages/Admin/UserManagement/UserList";
import AdminUserTable from "../pages/Admin/UserManagement/UserList";
import CompanyPage from "../pages/Companies/CompanyPage";
import CareersPage from "../pages/Footer/Carreers.js/Carreers";
import AdminCompanyTable from "../pages/Admin/CompaniesManagement/AdminCompanyManagement";
import RepresentativeDashboardUsers from "../pages/Representatives/Dashboard/RepresentativeUsers";
import RepresentativeDashboard from "../pages/Representatives/Dashboard/RepresentativeDashboard";
import RepresentativeFollowUps from "../pages/Representatives/Dashboard/RepresentativeFollowUps";
import RepresentativeCustomersReservation from "../pages/Representatives/RepresentativeCustomersReservation";
import StorePage from "../pages/Store/StorePage";
import CartPageShop from "../pages/Cart/CartPageShop";
import FindRepresentative from "../pages/Representatives/Search/FindRepresentative";
import RepresentativePublicProfileManagement from "../pages/Representatives/Dashboard/PublicProfileManagement";
import RepresentativePublicPage from "../pages/Representatives/Search/RepresentativePublicPage";
import RepresentativesList from "../pages/SellingDirector/RepresentativesList";
import RepresentativeDocuments from "../pages/Representatives/Dashboard/RepresentativeDocuments";
import ShippingManagementUserInterface from "../pages/Shipping/ShippingManagementUserInterface";
import PrivacyPolicy from "../pages/Footer/PrivacyPolicy/PrivacyPolicy";
import FAQPage from "../pages/Footer/FAQ/FAQ";
import CookieConsent from "../globalFunctions/CookieConsent";
import NewHomePage from "../pages/NewHomePage";
import Homepage2 from "../pages/HeroSection2";
import AboutUsPage from "../pages/AboutUs";
import NotFoundPage from "../pages/PageNotFound";
import ProviderInventoryManagement from "../pages/Provider/InventorySection/InventoryManagement";
import StorePaymentSuccess from "../pages/Store/Results/StorePaymentSuccess";
import StorePaymentFailed from "../pages/Store/Results/StorePaymentFailed";
import NewsPage from "../pages/News/NewsPage";
import ProviderNewsPage from "../pages/Provider/news/ProviderNewsPage";
import NewsArticlePage from "../pages/News/NewsArticlePage";
import AdminNewsPage from "../pages/Admin/News/AdminNewsPage";
import PermissionsManagementPage from "../pages/Management/Permissions/PermissionManagementPage";
import ManagementDashboard from "../pages/Management/Permissions/ManagementDashboard";

const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  // Si la route est "/", ne pas inclure le Layout
  const noLayoutRoutes = ["/", "/home", "/nhp"]; // Ajouter ici les routes sans Layout
  const isNoLayout = noLayoutRoutes.includes(location.pathname);

  return isNoLayout ? children : <Layout>{children}</Layout>;
};

function AppRoutes() {
  return (
    <Router>
      <LoadingOverlay />
      <LayoutWrapper>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route
            path="/become-partner"
            element={
              <ProtectedRoute>
                <BecomePartner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representant/:codeRepresentant"
            element={<RepresentativePublicPage />}
          />
          <Route
            path="/devenir-partenaire"
            element={
              <ProtectedRoute>
                <BecomePartner />
              </ProtectedRoute>
            }
          />

          <Route
            path="/management-dashboard"
            element={
              <ProtectedRoute>
                <ManagementDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/a-propos" element={<AboutUsPage />} />
          <Route path="/nhp" element={<Homepage2 />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/partners" element={<AllCompanies />} />
          <Route path="/entreprises" element={<AllCompanies />} />
          <Route path="/event/:id" element={<EventTicketPage />} />
          <Route path="/upcoming-events" element={<TicketingEventList />} />
          <Route path="/evenements-a-venir" element={<TicketingEventList />} />
          <Route path="/carrieres" element={<CareersPage />} />
          <Route
            path="/admin/management/permissions"
            element={<PermissionsManagementPage />}
          />

          <Route
            path="/representative-public-profile"
            element={
              <ProtectedRoute>
                <RepresentativePublicProfileManagement />
              </ProtectedRoute>
            }
          />
          <Route path="/actualites/:slug" element={<NewsArticlePage />} />
          <Route
            path="/ticketing/create"
            element={
              <ProtectedRoute>
                <CreateTicketingForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-news-validation-list"
            element={<AdminNewsPage />}
          />
          <Route
            path="/trouver-un-representant"
            element={<FindRepresentative />}
          />
          <Route
            path="/cart-store"
            element={
              <ProtectedRoute>
                <CartPageShop />
              </ProtectedRoute>
            }
          />
          <Route
            path="/boutique"
            element={
              <ProtectedRoute>
                <StorePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/current"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <CurrentOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representative/documents"
            element={
              <ProtectedRoute requiredPermission={["admin", "representative"]}>
                <RepresentativeDocuments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/knownissues"
            element={
              <ProtectedRoute requiredPermission={["admin", "representative"]}>
                <JiraTicketsTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/directeur-ventes/representatives-list"
            element={
              <ProtectedRoute
                requiredPermission={["admin", "selling_director"]}
              >
                <RepresentativesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/store/payment-success"
            element={<StorePaymentSuccess />}
          />
          <Route path="/actualites" element={<NewsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/actualités" element={<NewsPage />} />
          <Route
            path="/store/payment-failed"
            element={<StorePaymentFailed />}
          />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/compagnie/:slug" element={<CompanyPage />} />
          <Route path="/inventaire" element={<ProviderInventoryManagement />} />
          <Route path="/provider-news" element={<ProviderNewsPage />} />
          <Route
            path="/create-event"
            element={
              <ProtectedRoute>
                <CreateEventPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/creer-evenement"
            element={
              <ProtectedRoute>
                <CreateEventPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-companies"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <AdminCompanyTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representative-dashboard-users"
            element={
              <ProtectedRoute requiredPermission={["representative", "admin"]}>
                <RepresentativeDashboardUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representative-dashboard"
            element={
              <ProtectedRoute requiredPermission={["representative", "admin"]}>
                <RepresentativeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representative-customers-reservation"
            element={
              <ProtectedRoute requiredPermission={["representative", "admin"]}>
                <RepresentativeCustomersReservation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/representative-followups"
            element={
              <ProtectedRoute requiredPermission={["representative", "admin"]}>
                <RepresentativeFollowUps />
              </ProtectedRoute>
            }
          />
          <Route
            path="/success-subscription"
            element={
              <ProtectedRoute>
                <SubscriptionSuccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ticketings"
            element={
              <ProtectedRoute>
                <TicketingListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/success-donation"
            element={
              <ProtectedRoute>
                <SuccessDonation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/success"
            element={
              <ProtectedRoute>
                <SuccessPage />
              </ProtectedRoute>
            }
          />
          <Route path="/success-tickets" element={<TicketSuccess />} />
          <Route
            path="/my-orders"
            element={
              <ProtectedRoute>
                <MyOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-compte/compagnies"
            element={
              <ProtectedRoute>
                <RegisterCompany />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-orders-validation"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <OrdersToValidate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-tickets-validation"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <AdminTicketValidation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-user-list"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <AdminUserTable></AdminUserTable>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-user-list"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
          <Route
            path="/provider-dashboard"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ProviderDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard-product-list"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ProductsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fournisseur-gestion-expedition"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ShippingManagementUserInterface />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard/products/:id"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <CreateEditProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard/services/:id"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <CreateEditProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard-subscriptions"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ProviderSubscriptions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard-edit"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ProviderEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-dashboard-service-list"
            element={
              <ProtectedRoute requiredPermission={"provider"}>
                <ServicesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/become-provider"
            element={
              <ProtectedRoute>
                <BecomeProvider />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider/profile"
            element={
              <ProtectedRoute>
                <ProviderProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/providers-requests"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <ProviderRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/providers-list"
            element={
              <ProtectedRoute requiredPermission={"admin"}>
                <Providers />
              </ProtectedRoute>
            }
          />

          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default AppRoutes;
